import * as type from "./type";

const initialState = {
  list: [],
  categories: [],
  counts: {},
  vendors: [],
  totalRecords: 0,
  totalPages: 0,
  loading: false,
  canUpload: false,
  canDownload: false,
  uploading: false,
  uploadResult: null,

  shareWith: "",
  shareUsers: [],
  shareSelected: [],
  shareTargetsLoading: false,
  sharing: false,
  shareResult: null,

  statusUpdating: false,
};

const VendorDocumentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_VENDOR_DOCUMENTS_REQUEST:
      return { ...state, loading: true };
    case type.GET_VENDOR_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload?.list || [],
        categories: action.payload?.categories || state.categories,
        counts: action.payload?.counts || {},
        vendors: action.payload?.vendors || [],
        totalRecords: action.payload?.totalRecords || 0,
        totalPages: action.payload?.totalPages || 0,
        canUpload: !!action.payload?.canUpload,
        canDownload: !!action.payload?.canDownload,
      };
    case type.GET_VENDOR_DOCUMENTS_FAILURE:
      return { ...state, loading: false, list: [], totalRecords: 0, totalPages: 0 };

    case type.UPLOAD_VENDOR_DOCUMENT_REQUEST:
      return { ...state, uploading: true, uploadResult: null };
    case type.UPLOAD_VENDOR_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploadResult: {
          status: true,
          message: action.payload?.message || "",
          at: Date.now(),
        },
      };
    case type.UPLOAD_VENDOR_DOCUMENT_FAILURE:
      return {
        ...state,
        uploading: false,
        uploadResult: {
          status: false,
          message: action.payload?.message || "",
          at: Date.now(),
        },
      };

    case type.DELETE_VENDOR_DOCUMENT_REQUEST:
      return { ...state, loading: true };
    case type.DELETE_VENDOR_DOCUMENT_SUCCESS:
    case type.DELETE_VENDOR_DOCUMENT_FAILURE:
      return { ...state, loading: false };

    case type.GET_SHARE_TARGETS_REQUEST:
      return {
        ...state,
        shareTargetsLoading: true,
        shareWith: "",
        shareUsers: [],
        shareSelected: [],
      };
    case type.GET_SHARE_TARGETS_SUCCESS:
      return {
        ...state,
        shareTargetsLoading: false,
        shareWith: action.payload?.shareWith || "",
        shareUsers: action.payload?.users || [],
        shareSelected: action.payload?.sharedWith || [],
      };
    case type.GET_SHARE_TARGETS_FAILURE:
      return {
        ...state,
        shareTargetsLoading: false,
        shareUsers: [],
        shareSelected: [],
      };

    case type.SHARE_VENDOR_DOCUMENT_REQUEST:
      return { ...state, sharing: true, shareResult: null };
    case type.SHARE_VENDOR_DOCUMENT_SUCCESS:
      return {
        ...state,
        sharing: false,
        shareResult: {
          status: true,
          message: action.payload?.message || "",
          at: Date.now(),
        },
      };
    case type.SHARE_VENDOR_DOCUMENT_FAILURE:
      return {
        ...state,
        sharing: false,
        shareResult: {
          status: false,
          message: action.payload?.message || "",
          at: Date.now(),
        },
      };

    case type.UPDATE_VENDOR_DOCUMENT_STATUS_REQUEST:
      return { ...state, statusUpdating: true };
    case type.UPDATE_VENDOR_DOCUMENT_STATUS_SUCCESS:
    case type.UPDATE_VENDOR_DOCUMENT_STATUS_FAILURE:
      return { ...state, statusUpdating: false };

    default:
      return state;
  }
};

export default VendorDocumentsReducer;
